var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.1667H21.3333M22.6667 15.1667V16.5M10.6667 20.5V21.8333M16 21.8333L14.6667 23.1667M20 21.8333H21.3333M17.3333 16.5L18.6667 17.8333M28 16.5C28 23.1274 22.6274 28.5 16 28.5C9.37258 28.5 4 23.1274 4 16.5C4 15.8951 4.0817 15.3006 4.18759 14.7197C4.2336 14.4674 4.5517 14.3855 4.7331 14.5669C7.31056 17.1444 11.4894 17.1444 14.0669 14.5669C16.6444 11.9895 16.6444 7.81056 14.0669 5.2331C13.8861 5.05229 13.9682 4.73345 14.2198 4.68759C14.8006 4.5817 15.3951 4.5 16 4.5C22.6274 4.5 28 9.87259 28 16.5Z",
    stroke: "#1373E7",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/cookie.38b77518970f5460299b06b5458a1b54.svg";
export { ForwardRef as ReactComponent };